<script setup lang="ts">
defineProps({
  // eslint-disable-next-line vue/require-default-prop
  error: Object,
})

const isDevelopment = computed(() => process.env['NODE_ENV'] === 'development')
</script>

<template>
  <div class="w-screen h-screen flex flex-col items-center justify-center gap-4 py-8 text-center">
    <div>
      <div class="text-8xl font-bold">ERROR</div>
      <div class="text-xl">{{ error?.message }}</div>
    </div>
    <div
      v-if="(error?.statusMessage || error?.stack) && isDevelopment"
      class="overflow-x-scroll text-left text-xs"
    >
      <div v-dompurify-html="error?.statusMessage ?? error?.stack" />
    </div>
  </div>
</template>
